export const enum ScanTarget {
  // 0:バーコード
  BARCODE = 0,
  // 1:RFID
  RFID = 1,
  // 2:伝票
  ORDERNUMBER = 2
}
